import { useCallback } from 'react';
import { postProgramLog } from 'src/apis/programLogApi';
import { MenuDto } from 'src/dtos/menu/menuDto';
import { BookmarkCdList } from 'src/store/useCommonCodeStore';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { getMenuComponent, getMenuDisplayNm } from 'src/utils/menu/menuUtil';

export const useMenuOpen = () => {
	const { tabList, setActiveTab, addTabList } = useUiuxStore();

	/**
	 * menuCd + menuNm 프로그램 ID + 프로그램 명
	 *
	 * - 프로그램 로그 기록: setActiveTab? (X 프로그램 로그 기록)
	 * - 프로그램 로그 기록: addTabList + setActiveTab + postProgramLog
	 */
	const openMenu = useCallback((menuCd: string, menuNm: string) => {
		const exist = tabList.find(tab => tab.key === menuCd);

		if (exist) {
			setActiveTab(exist);
			return; // 이미 열려있는 메뉴라면 활성화만 처리
		}

		const newTab: Tab = {
			key: menuCd,
			title: getMenuDisplayNm(menuCd, menuNm),
			component: getMenuComponent(menuCd),
		};
		addTabList(newTab);
		setActiveTab(newTab);

		// fire-and-forget ? await 프로그램 로그 기록
		postProgramLog({ programId: menuCd });

	}, [tabList, setActiveTab, addTabList]);

	/** MenuDto 메뉴 열기 (Sidebar, TopbarMenu) */
	const openMenuFromDto = useCallback(
		(menu: MenuDto) => openMenu(menu.menuCd, menu.menuNm),
		[openMenu]
	);

	/** 즐겨찾기 메뉴 열기 */
	const openMenuFromBookmark = useCallback(
		(menu: BookmarkCdList) => openMenu(menu.key, menu.name),
		[openMenu]
	);

	return { openMenu, openMenuFromDto, openMenuFromBookmark };
};
